// assets
import { MessageSquare } from 'iconsax-reactjs';

// types
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS - TICKETS ||============================== //

const Tickets: NavItemType = {
  id: 'group-tickets',
  title: 'Tickets',
  type: 'group',
  visibleForUserTypes: ['assessorAdmin', 'assessor'],
  children: [
    {
      id: 'tickets',
      title: 'Tickets',
      type: 'item',
      url: '/tickets',
      icon: MessageSquare,
      breadcrumbs: false
    }
  ]
};

export default Tickets;
